import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  methods: {
    showToast(params, position = 'top-right') {
      if (!params.template) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: params.title,
            icon: params.icon,
            text: params.text,
            variant: params.variant,
          },
        }, {
          position,
        })
      } else if (params.template === 'saveSuccess') {
        this.showToast({
          variant: 'success',
          title: this.$store.state.app.saveSuccessTitle,
          icon: 'CheckCircleIcon',
          text: this.$store.state.app.saveSuccessMessage,
        })
      } else if (params.template === 'saveError') {
        this.showToast({
          variant: 'danger',
          title: this.$store.state.app.saveErrorTitle,
          icon: 'XCircleIcon',
          text: this.$store.state.app.saveErrorMessage,
        })
      } else if (params.template === 'removeSuccess') {
        this.showToast({
          variant: 'success',
          title: this.$store.state.app.removeSuccessTitle,
          icon: 'CheckCircleIcon',
          text: this.$store.state.app.removeSuccessMessage,
        })
      } else if (params.template === 'removeError') {
        this.showToast({
          variant: 'danger',
          title: this.$store.state.app.removeErrorTitle,
          icon: 'XCircleIcon',
          text: this.$store.state.app.removeErrorMessage,
        })
      } else if (params.template === 'requireWarning') {
        this.showToast({
          variant: 'warning',
          title: this.$store.state.app.requireTitle,
          icon: 'XCircleIcon',
          text: this.$store.state.app.requireWarning,
        }, 'bottom-center')
      }
    },
  },
}
